import { useGetUserByIdQuery } from '../services';
import { UserApi } from '../models';

type UseUserProps = {
  userId: string;
};

const useUser = ({ userId }: UseUserProps) => {
  const { data, isLoading, error } = useGetUserByIdQuery(
    { id: userId },
    { skip: !userId }
  );

  return {
    user: data ?? ({} as UserApi),
    isLoading,
    error,
  };
};

export default useUser;
